const ROUTES = {
  home: '/',
  policyAndTermsAndConditions: '/privacy-policy',
  termaAndConditions: '/terms-and-conditions'
};

export default ROUTES;
